"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var _classnames = _interopRequireDefault(require("classnames"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    root: {
      width: 40,
      height: 40,
      borderRadius: 40,
      backgroundColor: theme.palette.grey[200],
      fontSize: 16
    },
    selected: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.common.white
    },
    ripple: {
      backgroundColor: theme.palette.secondary.main
    },
    rippleSelected: {
      backgroundColor: theme.palette.grey[200]
    }
  };
});
/**
 * **The day selector button has two states, selected and unselected. It enables the user to freely choose which day they want. **
 *
 * There is 1 state: selected
 */

var PickerDay = function PickerDay(_ref) {
  var _classNames;

  var selected = _ref.selected,
      day = _ref.day,
      action = _ref.action;
  var styles = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.ButtonBase, {
    onClick: function onClick() {
      return action();
    },
    className: (0, _classnames.default)((_classNames = {}, _defineProperty(_classNames, styles.root, true), _defineProperty(_classNames, styles.selected, selected), _classNames)),
    TouchRippleProps: {
      classes: {
        child: selected ? styles.rippleSelected : styles.ripple
      }
    }
  }, day.substring(0, 2).toUpperCase());
};

PickerDay.propTypes = {
  day: _propTypes.default.string,

  /** The selected state of the picker */
  selected: _propTypes.default.bool,

  /** Action to call when click the picker */
  action: _propTypes.default.func.isRequired
};
PickerDay.defaultProps = {
  day: "MO",
  selected: false
};
var _default = PickerDay;
exports.default = _default;